import { render, staticRenderFns } from "./SectionKpiCard.vue?vue&type=template&id=12d2b968"
import script from "./SectionKpiCard.vue?vue&type=script&lang=ts"
export * from "./SectionKpiCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports